import React, { ReactNode } from 'react';
import { ErrorBoundary } from './ErrorBoundary';

interface SectionErrorBoundaryProps {
  children: ReactNode;
  sectionName: string;
}

const SectionErrorFallback: React.FC<{ sectionName: string; onRetry: () => void }> = ({
  sectionName,
  onRetry,
}) => {
  return (
    <div className="flex items-center justify-center p-8 bg-gray-50 rounded-lg">
      <div className="text-center max-w-md">
        <h2 className="text-xl font-semibold mb-3 text-gray-900">
          Error in {sectionName}
        </h2>
        <p className="text-gray-600 mb-4">
          We encountered an issue loading this section. Please try again.
        </p>
        <button
          onClick={onRetry}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
        >
          Retry
        </button>
      </div>
    </div>
  );
};

export const SectionErrorBoundary: React.FC<SectionErrorBoundaryProps> = ({
  children,
  sectionName,
}) => {
  const [key, setKey] = React.useState(0);

  const handleRetry = () => {
    setKey((prevKey) => prevKey + 1);
  };

  return (
    <ErrorBoundary
      key={key}
      fallback={<SectionErrorFallback sectionName={sectionName} onRetry={handleRetry} />}
    >
      {children}
    </ErrorBoundary>
  );
};
